var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-email-builder',{attrs:{"data":_vm.html},on:{"export":_vm.exportHtml}})}
var staticRenderFns = []

export { render, staticRenderFns }